import { useState } from "react"
import { useSnapshot } from "valtio"
import { AgSelect } from "../components/AgComponents"
import { configStore } from "../state/CommonState"
import { myactionsstore } from "../my-actions/store-myactions"
import { useGlobalState } from "../GlobalState"
import Agproducttab from "../components/Agproducttab"
import Visibility from "./visibility"
import Others from "./others"
import Pricing from "./pricing"
import Accounts from "./accounts"
import Schedules from "./schedules"
import PricingUploads from "./pricing-uploads"
import Transporter from "./transporter"
import AirPricingUploads from "./air-pricing-uploads"
import FCLPricingUploads from "./fcl-pricing-uploads"
import FBAPricingUploads from "./fba-pricing-uploads"
import CartingBooking from "./carting_booking"
import RoleUtils from "../util/RoleUtils"
import { PERMISSIONS_NEW } from "../util/constants"
import PricingExportUploads from "./pricing-export-uploads"

// let menuList = ['LCL Pricing', 'FCL Pricing', 'Air Pricing', 'FBA', 'Schedules', 'Visibility', 'Accounts', 'Others','Transporter Tariff']
//let menuList = ['Schedules', 'Visibility', 'Accounts', 'Others']
export default function Uploads() {
    const { leftMenuHidden, setLeftMenuHidden, changeCurrentMenu } = useGlobalState()
    const store = useSnapshot(myactionsstore)
    const [currentMenu, setCurrentMenu] = useState('')
    const [data, setData] = useState({})
    // let Comp = PricingUploads

    // if (currentMenu == 'Others') Comp = Others
    // else if (currentMenu == 'Visibility' && showVisibility) Comp = Visibility
    // else if (currentMenu == 'Accounts' && showAccounts) Comp = Accounts
    // else if (currentMenu == 'Schedules' && showSchedules) Comp = Schedules
    // else if (currentMenu == 'Transporter Tariff') Comp = Transporter
    // else if (currentMenu == 'Air Pricing' && showPricingData) Comp = AirPricingUploads
    // else if (currentMenu == 'FCL Pricing' && showPricingData) Comp = FCLPricingUploads
    // else if (currentMenu == 'LCL Pricing' && showPricingData) Comp = PricingUploads
    // else if (currentMenu == 'FBA' && showPricingData) Comp = FBAPricingUploads

    const permissions = {
        pricingData: RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOADS.PRICING_DATA),
        visibility: RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOADS.VISIBILITY_UPLOAD),
        schedules: RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOADS.SCHEDULE_UPLOAD),
        accounts: RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOADS.ACCOUNTS_TAB),
    }

    const menuListOrder = ['LCL Export Pricing', 'LCL Import Pricing', 'FCL Pricing', 'Air Pricing', 'FBA', 'Schedules', 'Visibility', 'Accounts', 'Others', 'Transporter Tariff', 'Carting & Booking']

    let menuList = menuListOrder.filter(menuItem => {
        switch (menuItem) {
            case 'LCL Export Pricing':
            case 'LCL Import Pricing':
            case 'FCL Pricing':
            case 'Air Pricing':
            case 'FBA':
                return permissions.pricingData
            case 'Visibility':
                return permissions.visibility
            case 'Schedules':
                return permissions.schedules
            case 'Accounts':
                return permissions.accounts
            case 'Others':
            case 'Transporter Tariff':
            case 'Carting & Booking':
                return true
            default:
                return false
        }
    });

    const defaultMenu = menuList[0] || 'Others'
    if (currentMenu === "") {
        setCurrentMenu(defaultMenu)
    }

    const componentsMap = {
        'Others': Others,
        'Visibility': permissions.visibility ? Visibility : null,
        'Accounts': permissions.accounts ? Accounts : null,
        'Schedules': permissions.schedules ? Schedules : null,
        'Transporter Tariff': Transporter,
        'Air Pricing': permissions.pricingData ? AirPricingUploads : null,
        'FCL Pricing': permissions.pricingData ? FCLPricingUploads : null,
        'LCL Export Pricing': permissions.pricingData ? PricingExportUploads : null,
        'LCL Import Pricing': permissions.pricingData ? PricingUploads : null,
        'FBA': permissions.pricingData ? FBAPricingUploads : null,
        'Carting & Booking': CartingBooking
    }

    let Comp = componentsMap[currentMenu] || Others;
    let errors = data.validationErrors
    return (
        <div>
            <h4 className="title is-3">Uploads</h4>
            <div className="columns">
                <div className="column is-12" style={{ zoom: '1.1' }}>
                    <Agproducttab productList={menuList}
                        activeProduct={currentMenu} setActiveProduct={setCurrentMenu} />
                </div>
            </div>
            <Comp />
        </div>
    )
}